import { Fragment } from 'react'

import { ContentPage_content_TextContent } from 'globalTypes'

import RenderedHtml from 'Root/Component/RenderedHtml'
import TopContent from 'Root/Pages/Content/Component/TopContent'

interface Props {
  content: ContentPage_content_TextContent
}

const DefaultStatus = ({ content }: Props) => {
  return (
    <Fragment>
      <TopContent content={content} />
      <RenderedHtml className="p-6" value={content.body} />
    </Fragment>
  )
}

export default DefaultStatus
